import { motion, useReducedMotion } from "motion/react";

/**
 * The liquid-glass lens under the active tab. Tabs that share a `group` hand the
 * lens over with a shared layout animation, so it flows between them on a spring
 * instead of jumping. Decorative only: state is carried by aria-current / aria-checked.
 */
export function GlassLens({ group }: { group: string }) {
  const reduce = useReducedMotion();
  return (
    <motion.span
      layoutId={`glass-lens-${group}`}
      className="glass-lens"
      aria-hidden="true"
      transition={reduce ? { duration: 0 } : { type: "spring", stiffness: 520, damping: 38, mass: 0.9 }}
    />
  );
}
